import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ProyectoEsquemasComponent {
  idProyecto
  idEsquema = null

  constructor ($location, $filter, FanProyectoEsquemasService) {
    this.$location = $location
    this.FanProyectoEsquemasService = FanProyectoEsquemasService
  }

  $onInit () {
    this.idEsquema = this.$location.hash() || null

    this.$promise = this.FanProyectoEsquemasService.get(this.idProyecto)
      .then(({data}) => (this.data = orderBy(data, ['nombre'])))
  }

  seleccionar (idEsquema) {
    this.idEsquema = idEsquema
    this.$location.hash(this.idEsquema)
  }

  actualizar (esquema, data) {
    if (!esquema || !data) return

    if (data && data.predeterminado) {
      this.data.forEach((item) => (item.predeterminado = item === data))
    }

    Object.assign(esquema, data)

    this.data = orderBy(this.data, ['nombre'])
  }
}

module.component('fanProyectoEsquemas', {
  controller: ProyectoEsquemasComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/component.js